/**
 * SHELL — owned by the Shell agent. PWA shell, UI, input capture, orchestration.
 *
 * Shell is the conductor: it derives the day, asks Core for the course, hands the
 * spec to Render, runs the fixed-timestep loop (capturing drag-to-steer into Core,
 * pulling GameState back out to Render), then builds a ScoreSubmission and talks
 * to Backend. Shell holds the wiring; it must not implement physics or rendering.
 *
 * This is the LOCKED PUBLIC SURFACE of Shell. The body is implemented across the
 * `src/shell/` modules and wired together in `./boot`.
 */

import { boot } from './boot';
import type { BootOptions } from './boot';

/**
 * Mount the whole experience into a root element and start the daily flow.
 *
 * To go live with real physics, pass Core's `createSimulation`:
 *   bootGame(root, { simulationFactory: (spec) => createSimulation(spec) })
 * Until then it runs on the fixtures' fake simulation — no call-site changes
 * elsewhere, because both satisfy the `Simulation` contract.
 */
export function bootGame(root: HTMLElement, options: BootOptions = {}): Promise<void> {
  return boot(root, options);
}

export type { BootOptions };
